// extracted by mini-css-extract-plugin
export default {"wrapper":"Confirmation_wrapper__fMSdw","confirmation":"Confirmation_confirmation__JKYjS","textBlock":"Confirmation_textBlock__t2OCA","buttons":"Confirmation_buttons__9EVP+"};